module.exports = __webpack_public_path__ + "static/media/znxt.99f8bafb.jpg";